import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=13830b8a&"
import script from "./DateRange.vue?vue&type=script&lang=ts&"
export * from "./DateRange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports